import { useState, useEffect, Fragment } from 'react';

function RssFeedPreview({ feed, onSubscribe, onCancel, isLoading }) {
    try {
        if (!feed) return null;

        return (
            <div className="bg-orange-50 border border-orange-200 rounded-lg p-6" data-name="rss-preview">
                <div className="flex justify-between items-start mb-4">
                    <h3 className="text-lg font-semibold text-orange-800">
                        RSS 源預覽
                    </h3>
                    <button
                        onClick={onCancel}
                        className="text-gray-400 hover:text-gray-600"
                        disabled={isLoading}
                        data-name="close-preview-button"
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="bg-white p-4 rounded-lg border border-orange-100 mb-4">
                    <div className="flex items-center mb-3">
                        {feed.thumb && (
                            <img 
                                src={feed.thumb} 
                                alt={feed.title} 
                                className="w-12 h-12 object-cover rounded mr-3"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = 'https://via.placeholder.com/48?text=RSS';
                                }}
                                data-name="feed-image"
                            />
                        )}
                        <div>
                            <h4 className="font-medium">{feed.title}</h4>
                            {feed.link && (
                                <a 
                                    href={feed.link} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="text-sm text-blue-600 hover:underline"
                                    data-name="feed-link"
                                >
                                    {feed.link}
                                </a>
                            )}
                        </div>
                    </div>

                    {feed.description && (
                        <p className="text-sm text-gray-600 mb-3 line-clamp-2" data-name="feed-description">
                            {feed.description}
                        </p>
                    )}

                    <div className="text-xs text-gray-500">
                        <span className="mr-3">
                            <i className="fas fa-newspaper mr-1"></i>
                            {feed.items.length} 篇文章
                        </span>
                        {feed.lastBuildDate && (
                            <span>
                                <i className="fas fa-clock mr-1"></i>
                                最後更新: {new Date(feed.lastBuildDate).toLocaleString('zh-TW')}
                            </span>
                        )}
                    </div>
                </div>

                <h4 className="font-medium mb-2">最新文章</h4>
                <div className="bg-white rounded-lg border border-orange-100 overflow-hidden mb-4">
                    <ul className="divide-y divide-orange-100">
                        {feed.items.slice(0, 5).map((item, index) => (
                            <li key={index} className="p-3 hover:bg-orange-50" data-name={`feed-item-${index}`}>
                                <a 
                                    href={item.link} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="block"
                                >
                                    <h5 className="font-medium text-gray-900 mb-1 line-clamp-1">{item.title}</h5>
                                    <div className="flex justify-between items-center">
                                        <p className="text-xs text-gray-500 line-clamp-1">
                                            {item.date && new Date(item.date).toLocaleString('zh-TW')}
                                        </p>
                                        <i className="fas fa-external-link-alt text-xs text-gray-400"></i>
                                    </div>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50 transition-colors"
                        disabled={isLoading}
                        data-name="cancel-button"
                    >
                        取消
                    </button>
                    <button
                        onClick={onSubscribe}
                        className="px-4 py-2 bg-orange-600 text-white rounded hover:bg-orange-700 transition-colors flex items-center"
                        disabled={isLoading}
                        data-name="subscribe-button"
                    >
                        {isLoading ? (
                            <Fragment>
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                訂閱中...
                            </Fragment>
                        ) : (
                            <Fragment>
                                <i className="fas fa-rss mr-2"></i>
                                訂閱
                            </Fragment>
                        )}
                    </button>
                </div>
            </div>
        );
    } catch (error) {
        console.error('RssFeedPreview component error:', error);
        reportError(error);
        return null;
    }
}

export default RssFeedPreview;